export default "__VITE_ASSET__N4cvCON___"